(() => {
  const originals = new WeakMap();
  const variantData = new WeakMap();
  const attributes = ['src', 'srcset', 'alt', 'width', 'height'];
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const audience = () => {
    const params = new URL(location.href).searchParams;
    const genders = params.getAll('filter.v.t.shopify.target-gender');
    if (genders.length) return genders.length === 1 ? ({'gid://shopify/TaxonomyValue/18':'mujeres','gid://shopify/TaxonomyValue/19':'hombres'}[genders[0]] || '') : '';
    const value = params.get('kom_audience');
    return ['hombres','mujeres'].includes(value) ? value : document.querySelector('[data-kom-default-audience]')?.dataset.komDefaultAudience || '';
  };
  const gender = value => /^(femenino|female|mujer|mujeres|woman|women)$/.test(normalize(value)) ? 'mujeres' : /^(masculino|male|hombre|hombres|man|men)$/.test(normalize(value)) ? 'hombres' : '';
  const copy = (from, to) => attributes.forEach(name => {
    const value = from.getAttribute(name);
    if (to.getAttribute(name) === value) return;
    if (value === null) to.removeAttribute(name); else to.setAttribute(name, value);
  });
  const updateVariant = (card, value) => {
    const dataNode = card.querySelector('[data-kom-card-variants]');
    if (!dataNode || !value) return;
    let data = variantData.get(dataNode);
    if (!data) { data = JSON.parse(dataNode.textContent); variantData.set(dataNode, data); }
    const currentId = card.dataset.variantId || String(data.defaultId);
    const current = data.variants.find(v => String(v.id) === currentId);
    const choices = data.variants.filter(v => !gender(v.options[data.genderIndex]) || gender(v.options[data.genderIndex]) === value);
    if (!choices.length) return;
    const selected = choices.find(v => String(v.id) === currentId) || choices.find(v => current && v.options.every((option, index) => index === data.genderIndex || option === current.options[index])) || choices[0];
    const id = String(selected.id);
    if (card.dataset.variantId !== id) card.dataset.variantId = id;
    card.querySelectorAll('a[href*="/products/"]').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.searchParams.get('variant') !== id) { url.searchParams.set('variant', id); link.href = url.pathname + url.search; }
    });
    card.querySelectorAll('input[name="id"]').forEach(input => {input.value = id;});
    card.querySelectorAll('quick-buy-modal').forEach(modal => {
      const handle = card.getAttribute('handle') + '?variant=' + id;
      if (modal.getAttribute('handle') !== handle) modal.setAttribute('handle', handle);
    });
    const sale = card.querySelector('sale-price');
    if (sale) {
      const label = sale.querySelector('.sr-only');
      const text = [...sale.childNodes].find(node => node.nodeType === 3 && node.textContent.trim());
      if (text && text.textContent.trim() !== selected.price) text.textContent = selected.price;
      else if (!text) sale.append(document.createTextNode(selected.price));
    }
  };
  const update = () => {
    const value = audience();
    document.querySelectorAll('product-card').forEach(card => {
      updateVariant(card, value);
      const primary = card.querySelector('.product-card__image--primary');
      if (!primary) return;
      const image = value && card.querySelector('template[data-kom-audience-image="' + value + '"]')?.content.querySelector('img');
      let saved = originals.get(primary);
      if (image) {
        if (!saved) {
          saved = {image: primary.cloneNode(), secondary: card.querySelector('.product-card__image--secondary'), audience: ''};
          if (saved.secondary) saved.hidden = saved.secondary.hidden;
          originals.set(primary, saved);
        }
        copy(image, primary);
        const secondary = card.querySelector('.product-card__image--secondary');
        if (secondary) secondary.hidden = true;
        saved.audience = value;
      } else if (saved?.audience) {
        copy(saved.image, primary);
        if (saved.secondary) saved.secondary.hidden = saved.hidden;
        saved.audience = '';
      }
    });
    const context = new URL(location.href).searchParams.get('kom_audience');
    if (!['hombres','mujeres'].includes(context)) return;
    document.querySelectorAll('facets-form form').forEach(form => {
      let input = form.querySelector('input[name="kom_audience"]');
      if (!input) {input = document.createElement('input');input.type = 'hidden';input.name = 'kom_audience';form.append(input);}
      input.value = context;
    });
  };
  let queued = false;
  const schedule = () => {if (!queued) {queued = true;queueMicrotask(() => {queued = false;update();});}};
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' ? record.target.matches('product-card, .product-card__image--primary') : [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('product-card, facets-form') || node.querySelector('product-card, facets-form'))))) schedule();
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-variant-id','src','srcset']});
  window.addEventListener('popstate', schedule);
  window.addEventListener('click', event => {
    const link = event.target.closest?.('facet-link a, .pagination a, .kom-collection-summary a');
    const context = new URL(location.href).searchParams.get('kom_audience');
    if (!link || !['hombres','mujeres'].includes(context)) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname) {url.searchParams.set('kom_audience', context);link.href = url.href;}
  }, true);
  update();
})();
